import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import { ORANGE } from '../../../../shared/colors';
import { updatePassword } from '../network';

const FormShell = styled.div`
  color: var(--mt-text);

  .form-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
    background: var(--mt-surface);
  }

  .form-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .ant-input,
  .ant-input-password {
    min-height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .submit-button {
    min-width: 190px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, #ffb000);
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const PasswordForm = ({
  user,
  setShowDrawer,
}: {
  user: UserEntity;
  setShowDrawer: (b: boolean) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  return (
    <FormShell>
      <div className='form-intro'>
        <span>Réinitialisation sécurisée</span>
        <h3>{user?.nom} {user?.prenom}</h3>
      </div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{ password, confirm }}
        onFinish={async (data) => {
          setIsLoading(true);
          const { password } = data;

          if (user) {
            await updatePassword(user.url, password).then(
              ({ data, statusCode }) => {
                if (statusCode?.toString()[0] === '2') {
                  notification.success({
                    message: 'Succès',
                    description:
                      'Le mot de passe a été réinitialisé avec succès',
                  });
                  setShowDrawer(false);
                  setPassword('');
                  setConfirm('');
                } else {
                  notification.info({
                    message: 'Erreur',
                    description: data.message || statusCode,
                  });
                }
                setIsLoading(false);
              },
            );
          }
        }}
      >
        <Form.Item
          label='Mot de passe'
          name='password'
          rules={[
            {
              required: true,
              message: 'Entrez votre mot de passe!',
            },
          ]}
        >
          <Input.Password placeholder='Entrer le nouveau mot de passe' />
        </Form.Item>

        <Form.Item
          label='Confirmer mot de passe'
          name='confirm'
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: 'Veuillez confirmer votre mot de passe!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    'Les deux mots de passe que vous avez saisis ne correspondent pas!',
                  ),
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder='Confirmer le nouveau mot de passe' />
        </Form.Item>

        <Form.Item>
          <Button
            className='submit-button'
            htmlType='submit'
            loading={isLoading}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
